/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-04-15 20:33:50
 * @FilePath: \client-h5\src\pages\my\services.js
 */
import http from '../../utils/http';
//退出登录
export function loginout() {
  return http("get", '/my/logout');
}
//个人信息
export function getUserInfo() {
  return http("get", '/my/getCurrentUser');
}


